/**
 * Format information about a ClientUserLogin for display. Can optionally
 * include email, and will include role information if present in login or
 * specified as separate param
 * @param {*} clientLogin
 * @param {*} clientRole
 * @param {Boolean} showEmail
 */
export function formatBasicUserInfoForDisplay(clientLogin, clientRole, showEmail) {
    if (clientLogin == null) {
        return "";
    }

    const anonUserRoleDisplayName = "Not registered for program";

    clientRole = clientRole || clientLogin.RoleDisplayInfo;
    const roleStr = clientRole != null ? clientRole.DisplayName : "";
    const emailStr = showEmail && roleStr != anonUserRoleDisplayName ? clientLogin.Email : "";

    let emailRoleStr = "";
    if (roleStr) {
        if (emailStr) {
            emailRoleStr = ` (${emailStr} - ${roleStr})`;
        } else {
            emailRoleStr = ` (${roleStr})`;
        }
    } else if (emailStr) {
        emailRoleStr = ` (${emailStr})`;
    }
    const lastNameStr = clientLogin.LastName ? ` ${clientLogin.LastName}` : "";

    return `${clientLogin.FirstName}${lastNameStr}${emailRoleStr}`;
}

export function userHasPrivilege(clientRole, rolePrivilege) {
    return clientRole.RolePrivileges[rolePrivilege];
}

export function userHasAdminPrivilege(clientRole, rolePrivilege) {
    return clientRole.IsProgramAdmin && userHasPrivilege(clientRole, rolePrivilege);
}

export function userIsCPAdmin(clientRole) {
    return clientRole.IsCPAdmin;
}

export function mapLoggedInUserData(loggedInUser, loggedInRole) {
    if (!loggedInUser || !loggedInRole) {
        return {};
    }
    return {
        loggedInUserIsCPAdmin: loggedInRole.IsCPAdmin,
        loggedInUserIsReadOnly: loggedInRole.IsReadOnly,
        loggedInUserIsReadOnlyCPAdmin: loggedInRole.IsCPAdmin && loggedInRole.IsReadOnly,
        loggedInUserHasMfa: loggedInUser.HasMfaEnabled,
        loggedInUserIsSsoInProgram: loggedInUser.IsSsoInProgram,
        loggedInUserHasViewSensitiveDataPrivilege: loggedInUser.HasViewSensitiveDataPrivilege
    };
}

export const MAX_EMAIL_LENGTH = 128;
